import { render, staticRenderFns } from "./GroupMembershipModal.vue?vue&type=template&id=ba409b40&scoped=true&"
import script from "./GroupMembershipModal.vue?vue&type=script&lang=js&"
export * from "./GroupMembershipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba409b40",
  null
  
)

export default component.exports